module.exports = __webpack_public_path__ + "static/media/heart-shape-locket-print.4887ce55.png";